import { render, staticRenderFns } from "./SettingsEditor.vue?vue&type=template&id=3b39a33c&scoped=true&"
import script from "./SettingsEditor.vue?vue&type=script&lang=js&"
export * from "./SettingsEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b39a33c",
  null
  
)

export default component.exports